import { render, staticRenderFns } from "./PracticeAncillaryServiceTestsModifyPage.vue?vue&type=template&id=6e0c8eca&scoped=true"
import script from "./PracticeAncillaryServiceTestsModifyPage.vue?vue&type=script&lang=js"
export * from "./PracticeAncillaryServiceTestsModifyPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeAncillaryServiceTestsModifyPage.vue?vue&type=style&index=0&id=6e0c8eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c8eca",
  null
  
)

export default component.exports